import currentUserCan from "../helpers/currentUserCan";
import store from "../store";
import permissions from "../constants/permissions";

const auth = {
  install: (Vue) => {
    Vue.prototype.$currentUserCan = (permission) => {
      let me = store.getters["profile/me"];
      return currentUserCan(me, permission);
    };
    Vue.prototype.$currentUser = () => {
      return store.getters["profile/me"];
    };
    Vue.prototype.$permissions = permissions;
    Vue.prototype.$currentUserIsLevelOrganization = () => {
      let me = store.getters["profile/me"];
      return !!me.organization?.id;
    };
    Vue.prototype.$currentUserIsLevelReseller = () => {
      let me = store.getters["profile/me"];
      return !!me.reseller?.id && !me.organization?.id;
    };
    Vue.prototype.$currentUserIsLevelAdmin = () => {
      let me = store.getters["profile/me"];
      return me.is_staff && !me.organization?.id && !me.reseller?.id;
    };
    Vue.prototype.$currentUserOrganizationId = () => {
      let me = store.getters["profile/me"];
      return me.organization?.id;
    };
    Vue.prototype.$currentUserResellerId = () => {
      let me = store.getters["profile/me"];
      return me.reseller?.id;
    };
    // Works for a production cafeteria (computed by the API on /me only).
    Vue.prototype.$currentUserManagesProductionCafeteria = () => {
      let me = store.getters["profile/me"];
      return !!me?.manages_production_cafeteria;
    };
    // At least one reachable establishment still produces weekly reports.
    Vue.prototype.$currentUserDoesWeeklyReports = () => {
      let me = store.getters["profile/me"];
      if (!me?.restrict_to_establishments) {
        return true;
      }
      // A profile refreshed without its includes must not hide the menus.
      if (!Array.isArray(me.allowedEstablishments)) {
        return true;
      }
      return me.allowedEstablishments.some(
        (establishment) => establishment.weekly_reports_enabled !== false
      );
    };
  },
};

export default auth;
